import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _SVGIconWithSizes;

import { createSvg } from "../createSvg";
import { IconSize, SVGIconWithSizes } from "../interfaces";
export default createSvg('IconUnderline', new SVGIconWithSizes((_SVGIconWithSizes = {}, _defineProperty(_SVGIconWithSizes, IconSize.ExtraSmall, {
  paths: ['M10.7162 0.800003H12.3301V8.32296C12.4068 9.57811 12.0056 10.8128 11.2189 11.7425C10.338 12.5896 9.17849 13.0207 8.00002 12.9393C6.82893 13.0363 5.67032 12.626 4.78113 11.7995C3.99131 10.868 3.5898 9.62897 3.66994 8.37045V0.800003H5.2838V8.47494C5.2383 9.2853 5.48827 10.0828 5.9805 10.6976C6.52629 11.2432 7.25712 11.5216 8.00002 11.467C8.74292 11.5216 9.47376 11.2432 10.0195 10.6976C10.5118 10.0828 10.7617 9.2853 10.7162 8.47494V0.800003ZM2.40002 15.2V13.8322H13.6V15.2H2.40002Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), _defineProperty(_SVGIconWithSizes, IconSize.Small, {
  paths: ['M13.0241 2H14.8209V10.3754C14.9062 11.7728 14.4595 13.1474 13.5838 14.1824C12.6031 15.1255 11.3121 15.6055 10.0001 15.5149C8.69632 15.6228 7.40642 15.1661 6.41647 14.2459C5.53715 13.2089 5.09014 11.8294 5.17937 10.4283V2H6.9761V10.5446C6.92544 11.4468 7.20374 12.3347 7.75174 13.0192C8.35938 13.6266 9.17303 13.9366 10.0001 13.8758C10.8272 13.9366 11.6408 13.6266 12.2485 13.0192C12.7965 12.3347 13.0748 11.4468 13.0241 10.5446V2ZM3.76544 18.2903V16.509H16.2346V18.2903H3.76544Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), _defineProperty(_SVGIconWithSizes, IconSize.Medium, {
  paths: ['M16.0743 1.2H18.4951V12.4844C18.6101 14.3672 18.0083 16.2192 16.8283 17.6137C15.507 18.8844 13.7677 19.5311 12 19.409C10.2433 19.5544 8.50543 18.939 7.17163 17.6992C5.9869 16.302 5.38464 14.4435 5.50486 12.5557V1.2H7.92564V12.7124C7.85739 13.928 8.23234 15.1242 8.97068 16.0464C9.78937 16.8648 10.8856 17.2825 12 17.2005C13.1143 17.2825 14.2106 16.8648 15.0293 16.0464C15.7676 15.1242 16.1426 13.928 16.0743 12.7124V1.2ZM3.59998 22.7483V20.7483H20.4V22.7483H3.59998Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), _defineProperty(_SVGIconWithSizes, IconSize.Large, {
  paths: ['M21.4324 1.6H24.6601V16.6459C24.8135 19.1562 24.0111 21.6255 22.4378 23.485C20.676 25.1792 18.3569 26.0414 16 25.8786C13.6578 26.0726 11.3406 25.252 9.56219 23.5989C7.98255 21.736 7.17953 19.2579 7.33983 16.7409V1.6H10.5675V16.9499C10.4765 18.5706 10.9765 20.1656 11.9609 21.3952C13.0525 22.4864 14.5142 23.0433 16 22.934C17.4858 23.0433 18.9475 22.4864 20.039 21.3952C21.0235 20.1656 21.5234 18.5706 21.4324 16.9499V1.6ZM4.79999 30.4V27.6644H27.2V30.4H4.79999Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));